import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";

// Connects to data-controller="flatpickr"
export default class extends Controller {
  static values = {
    disabledDates: Object,
    minDate: String,
    maxDate: String,
  };

  connect() {
    this.selectedDisabledDates = this.disabledDatesValue[1];
    this.flatpickr = flatpickr(this.element, {
      locale: Russian,
      minDate: this.minDateValue,
      maxDate: this.maxDateValue,
      disable: this.selectedDisabledDates,
      altInput: true,
      altFormat: "d.m.Y",
    });
    this.#initEventHooks();
  }

  changeDisabledDates({ detail: { branchId } }) {
    this.selectedDisabledDates = this.disabledDatesValue[branchId];
    this.flatpickr.set("disable", this.selectedDisabledDates);
  }

  #initEventHooks() {
    this.flatpickr.config.onChange.push(() => {
      this.dispatch("change");
    });
  }
}
